import { useMemo } from 'react';
import { shortenPositionName } from '../utils/dataProcessing/positionSorting';

export function useChartData(sortedPositions) {
  return useMemo(() => {
    return sortedPositions.map(item => {
      // Use Total Cash for all comparisons
      const currentTotalCash = item.salary.peerigonCurrentTotalCash;
      const currentMonthly = currentTotalCash / 12;
      
      // Calculate monthly adjustments for each source using Total Cash
      const marketAdjustment = item.salary.medianTotalCashMonthlyToIncrease || 0;
      const kununuAdjustment = item.kununu ? 
        Math.round((item.kununu.averageSalary / 12) - currentMonthly) : null;
      const gehaltDeAdjustment = item.gehaltDe ? 
        Math.round((item.gehaltDe.averageSalary / 12) - currentMonthly) : null;
      
      return {
        name: shortenPositionName(item.positionsBezeichnung),
        fullName: item.positionsBezeichnung,
        current: Math.round(currentTotalCash / 1000),
        market: Math.round(item.salary.medianTotalCash / 1000),
        kununu: item.kununu ? Math.round(item.kununu.averageSalary / 1000) : null,
        gehaltDe: item.gehaltDe ? Math.round(item.gehaltDe.averageSalary / 1000) : null,
        difference: marketAdjustment,
        marketAdjustment,
        kununuAdjustment,
        gehaltDeAdjustment,
        hasKununu: !!item.kununu,
        hasGehaltDe: !!item.gehaltDe,
        kununuUrl: item.kununu?.config?.kununuUrl,
        kununuPosition: item.kununu?.position,
        gehaltDeUrl: item.gehaltDe?.config?.gehaltDeUrl,
        gehaltDePosition: item.gehaltDe?.position
      };
    });
  }, [sortedPositions]);
}

export function useDifferenceChartData(chartData) {
  return useMemo(() => {
    return chartData.filter(item => item.difference > 0);
  }, [chartData]);
}

export function useAdjustmentChartData(chartData) {
  return useMemo(() => {
    return chartData.filter(item => 
      item.marketAdjustment > 0 || 
      (item.kununuAdjustment && item.kununuAdjustment > 0) ||
      (item.gehaltDeAdjustment && item.gehaltDeAdjustment > 0)
    );
  }, [chartData]);
}